import React from 'react';

const Landing = () => {
    // This is the landing page of the app

    return (
        <div className='landing-container'>
            <h1
                className='text landing landing-text'
                style={{ fontStyle: 'italic' }}
            >
                Peril & Intrigue await...
            </h1>
        </div>
    );
};

export default Landing;
